import { useQuery } from '@tanstack/react-query';
import type { TenantDto, TenantUsageDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface TenantMeApiResponse {
  success: boolean;
  data: {
    tenant: TenantDto;
    usage: TenantUsageDto;
  };
}

/**
 * Hook to fetch the current tenant settings and usage metrics.
 * Calls GET /tenant/me.
 */
export function useTenantMe(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.tenant.me(),
    queryFn: async () => {
      const response = await apiClient.get<TenantMeApiResponse>('/tenant/me');
      return response.data.data;
    },
    ...options,
  });
}
